import { PartyModel } from '../../types';
import { routes } from '../../routes/routes';

interface DeleteGroupResponse {
  statusCode: number;
}

interface DeleteGroupSuccessOptions {
  groupId: string;
  myPartiesInfo: PartyModel[];
  deleteGroup: (groupId: string) => Promise<DeleteGroupResponse>;
  setMyPartiesInfoContextData: (parties: PartyModel[]) => void;
  onHide: () => void;
  navigate: (route: string) => void;
}

export const deleteGroupAndCloseModal = async ({
  groupId,
  myPartiesInfo,
  deleteGroup,
  setMyPartiesInfoContextData,
  onHide,
  navigate,
}: DeleteGroupSuccessOptions) => {
  const response = await deleteGroup(groupId);

  if (response.statusCode !== 200) {
    throw new Error('Failed to delete the group.');
  }

  const updatedPartiesInfo = myPartiesInfo.filter((partyInfo) => partyInfo.party.id !== groupId);

  setMyPartiesInfoContextData(updatedPartiesInfo);
  onHide();
  navigate(routes.MyParties);

  return updatedPartiesInfo;
};
